<!-- Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. -->

<form [formGroup]="internalCustomFieldFilter" class="custom-field-filter-container">
	<!-- Alt version
		<mat-form-field appearance="outline">
			<mat-label automationId="cf-filter-label">{{title}}</mat-label>
			<mat-select formControlName="customField">
				<mat-option>&lt;not set&gt;</mat-option>
				<mat-option *ngFor="let customField of customFieldDefinitionArray$ | async" [value]="customField">
					<div>{{ customField.view.label }}</div>
				</mat-option>
			</mat-select>
		</mat-form-field>
		-->

	<mat-extended-select
		class="full-width"
		formControlName="customField"
		automationId="cf-filter-label"
		[placeholder]="title"
		[includeFilter]="true"
		[required]="false"
		[option$]="customFieldDefinitionsEnabledOnly$"
		[includeNotSetOption]="true"
		[isNotSetValid]="true"
		[labelPath]="['view', 'label']"
		[valuePath]="[]"
	>
	</mat-extended-select>

	<mat-chip-listbox
		formControlName="operator"
		[compareWith]="chipComparator"
		(blur)="onTouched()"
		class="chip-container"
	>
		<mat-chip-option
			#chipApi
			automationId="customFieldFilterOperator"
			*ngFor="let operator of chipOperator$ | async"
			[value]="operator"
			[selectable]="internalCustomFieldFilter.get('operator').value?.key !== operator.key"
		>
			{{ operator.label }}
		</mat-chip-option>
	</mat-chip-listbox>

	<ng-container [ngSwitch]="(selectedCustomField$ | async)?.view.type">
		<custom-field-number
			*ngSwitchCase="'number'"
			automationId="customFieldNumber"
			[customField]="selectedCustomField$ | async"
			(blur)="onTouched()"
			formControlName="value"
		>
		</custom-field-number>
		<custom-field-dropdown
			*ngSwitchCase="'dropDownList'"
			automationId="customFieldDropDownList"
			[customField]="selectedCustomField$ | async"
			(blur)="onTouched()"
			[multiSelect]="true"
			[required]="true"
			formControlName="value"
		>
		</custom-field-dropdown>
		<custom-field-text
			*ngSwitchCase="'text'"
			automationId="customFieldText"
			[customField]="selectedCustomField$ | async"
			(blur)="onTouched()"
			formControlName="value"
		>
		</custom-field-text>
		<custom-field-text
			*ngSwitchCase="'link'"
			automationId="customFieldLink"
			[customField]="selectedCustomField$ | async"
			(blur)="onTouched()"
			formControlName="value"
		>
		</custom-field-text>
		<div *ngSwitchDefault></div>
	</ng-container>
</form>
